import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'noSanitize',
    standalone: false
})  // noSanitize是在html中使用管道时的名称
export class NoSanitizePipe implements PipeTransform {
    constructor(private domSanitizer: DomSanitizer) { }

    transform(html: string): SafeHtml {
        return this.domSanitizer.bypassSecurityTrustHtml(html);
    }
}
